import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 8 7.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 7.999\" id=\"icon-close\"><defs><style>#icon-close .a{fill:#0938f7;}</style></defs><path class=\"a\" d=\"M202.692,202.123l.005.005,3.251,3.251,3.251-3.251a.439.439,0,0,1,.626.615l-.006,0L206.568,206l3.251,3.251a.439.439,0,0,1-.615.626l0-.006-3.251-3.251-3.251,3.251a.439.439,0,0,1-.626-.615l.005-.005L205.328,206l-3.25-3.25a.438.438,0,0,1,.614-.624Z\" transform=\"translate(-201.949 -201.999)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol